// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M21 21H3V3H21V21ZM8 12L12.001 16.001L16.001 12L12.001 7.99902L8 12Z" fill="#F6DB55"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M21 21H3V3H21V21ZM8 12L12.001 16.001L16.001 12L12.001 7.99902L8 12Z" style="fill: currentColor"/></svg>`;

export const XsollaGold: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
